<af-main-container [title]="(incidentId ? 'i18n_lib_breadcrumb#EditIncident' : 'i18n_lib_breadcrumb#CreateIncident') | translate"
                   spinnerIds="initial"
                   [customLastBreadcrumb]="incidentId && ('i18n_lib_breadcrumb#IncidentId' | translate:{incidentId: incidentId})"
                   [navigateBackListener]="navigateBack"
                   [specialFilter]="incidentId && filterIncidentIdPath">
    @if (incidentId || hasReachedLastStep) {
        <div CustomTitle
             fxFlex
             fxLayout="row" fxLayoutAlign="end center" class="w-100">
            <ui-kit-button [label]="'i18n_af_buttonCancel' | translate"
                           type="secondary"
                           [disabled]="Spinner.isShown('createIncident') || Spinner.isShown('editIncident')"
                           (clickListener)="openCancellationWarningDialog()"/>
            <ui-kit-button [label]="'i18n_af_buttonSave' | translate"
                           class="ml-16"
                           [spinnerId]="incidentId ? 'editIncident' : 'createIncident'"
                           (clickListener)="sendRequest()"/>
        </div>
    }
    @if (!incidentId) {
        <div class="w-100 h-100" fxLayout="column" fxLayoutAlign="start start" fxFlex>
            <ui-kit-stepper #stepper class="mt-32"
                            [hasNavigation]="true"
                            [canNavigate]="currentStepFormValid"
                            [currentStep]="currentStep"
                            [steps]="steps"
                            [isStepCompleted]="isStepCompleted"
                            (stepIndexChangeListener)="onStepChange($event)"/>
            <div fxLayout="column" fxLayoutAlign="start start" class="w-100 h-100 overflow-y-hidden">
                @for (step of steps; track step) {
                    @if (step === 'incident' && step === currentStep) {
                        <af-common-information-step
                            [form]="form.controls.commonInformationForm"
                            class="w-100 mt-24 h-fit-content overflow-y-scroll"
                            (typeChangeListener)="changeStepper($event)"
                            (nextStep)="stepper.nextStep()"
                            fxFlex
                            (cancel)="openCancellationWarningDialog()"/>
                    }
                    @if (step === 'contactDetails' && step === currentStep) {
                        <af-contact-details-step
                            [form]="form.controls.contactDetailsForm"
                            class="w-100 mt-24 h-fit-content overflow-y-scroll"
                            fxFlex
                            (nextStep)="stepper.nextStep()"
                            (cancel)="openCancellationWarningDialog()"/>
                    }
                    @if (step === 'amount' && step === currentStep) {
                        <af-amount-information-step
                            [form]="form.controls.incidentAmountForm"
                            class="w-100 mt-24 h-fit-content overflow-y-scroll"
                            fxFlex
                            (nextStep)="stepper.nextStep()"
                            (cancel)="openCancellationWarningDialog()"/>
                    }
                    @if (step === currentStep && step === 'msisdnFraudEntries') {
                        <af-msisdn-fraud-step
                            [form]="form.controls.msisdnFraudEntriesForm"
                            class="w-100 mt-24 h-fit-content overflow-y-scroll"
                            fxFlex/>
                    }
                    @if (step === currentStep && lastSteps.includes(step) && step !== 'msisdnFraudEntries') {
                        <af-transaction-information-step
                            [form]="form.controls.transactionsForm"
                            class="w-100 mt-24 h-fit-content overflow-y-scroll"
                            fxFlex/>
                    }
                }
            </div>
        </div>
    }
    @if (incidentId) {
        <div class="w-100 h-100 mt-24" fxLayout="column" fxLayoutAlign="start start" fxFlex>
            @if (form?.controls) {
                <div fxLayout="column"
                     fxLayoutAlign="start start"
                     fxFlex
                     class="w-100 h-100 overflow-y-scroll">
                    <af-common-information-step [form]="form.controls.commonInformationForm"
                                                [incident]="incidentResponse"
                                                class="w-100"
                                                (typeChangeListener)="changeStepper($event)"
                                                (cancel)="openCancellationWarningDialog()"/>
                    @if (form?.controls?.contactDetailsForm) {
                        <af-contact-details-step [form]="form.controls.contactDetailsForm"
                                                 [incident]="incidentResponse"
                                                 class="w-100 mt-12"
                                                 (cancel)="openCancellationWarningDialog()"/>
                    }
                    @if (form?.controls?.incidentAmountForm) {
                        <af-amount-information-step
                            [form]="form.controls.incidentAmountForm"
                            [incident]="incidentResponse"
                            class="w-100 mt-12"
                            (cancel)="openCancellationWarningDialog()"/>
                    }
                </div>
            }
        </div>
    }
</af-main-container>
